const languageList = {
    "USA": "en-US",
    "DENMARK": "da-DK"
}
const currencyList = {
    "USA": { style: 'currency', currency: 'USD' },
    "DENMARK": { style: 'currency', currency: 'DKK' }
}
export function getCurrencyFormat(country: string, amount: number, shortFormat: boolean = false): string {
    if (shortFormat) {
        return new Intl.NumberFormat(languageList[country], { ...currencyList[country], minimumFractionDigits: 0 }).format(amount);
    } else {
        return new Intl.NumberFormat(languageList[country], currencyList[country]).format(amount);
    }
}

export function getCurrencySymbol(country: string, amount: number) {
    var currencyFormat = getCurrencyFormat((country == null || country.length == 0) ? "USA" : country, amount, false);
    return currencyFormat.replace(/[0-9.;,.\s]/g, "");
}
